module.exports = __webpack_public_path__ + "static/media/piano.bd51b5e7.svg";